import { useFormState } from "react-hook-form";
import { StyleSheet, View } from "react-native";
import { CollapsibleView, ThemedText } from "@luna-restaurant/ui";
export function FormError({ reserveSpace = true }) {
    const { errors } = useFormState();
    const rootError = errors.root?.message ?? "";
    if (!reserveSpace) {
        return (<CollapsibleView isVisible={Boolean(rootError)}>
        <ThemedText type="danger" style={styles.errorText}>
          {String(rootError)}
        </ThemedText>
      </CollapsibleView>);
    }
    return (<View style={styles.container}>
      <ThemedText type="danger" style={styles.errorText}>
        {String(rootError)}
      </ThemedText>
    </View>);
}
const styles = StyleSheet.create({
    container: {
        marginBottom: 8,
        height: 36, // to prevent layout shifts
    },
    errorText: {
        fontSize: 16,
        textAlign: "center",
    },
});
//# sourceMappingURL=FormError.js.map